__turbopack_context__.v({
  "button": "P52ODq_button",
  "container": "P52ODq_container",
  "headline": "P52ODq_headline",
  "icon": "P52ODq_icon",
  "text": "P52ODq_text",
});
